import { useState } from 'react';
import { ChevronDown, ChevronUp, BrainCircuit } from 'lucide-react';
import type { IntentClassification } from '../types';

interface SystemReasoningPanelProps {
  classification: IntentClassification;
}

const SystemReasoningPanel = ({ classification }: SystemReasoningPanelProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white/90 shadow-sm">
      <button
        onClick={() => setIsOpen((current) => !current)}
        className="flex w-full items-center justify-between px-4 py-3 text-left"
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-700">
            <BrainCircuit className="h-4 w-4" />
          </div>
          <div>
            <p className="text-sm font-semibold text-slate-900">System Reasoning</p>
            <p className="text-xs text-slate-500">
              Intent: {classification.intent} · Confidence: {Math.round(classification.confidence * 100)}%
            </p>
          </div>
        </div>
        {isOpen ? <ChevronUp className="h-4 w-4 text-slate-500" /> : <ChevronDown className="h-4 w-4 text-slate-500" />}
      </button>

      {isOpen && (
        <div className="border-t border-slate-200 px-4 py-4">
          <ul className="space-y-2 text-sm text-slate-600">
            {classification.reasoning.map((reason, index) => (
              <li key={index} className="rounded-xl bg-slate-50 px-3 py-2">
                {reason}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SystemReasoningPanel;